const actions = {
  SET_STATE: 'parkingsessions/SET_STATE',
  GET: 'parkingsessions/GET',
  GET_SUCCESS: 'parkingsessions/GET_SUCCESS',
  GET_ERROR: 'parkingsessions/GET_ERROR',
};

export default actions;
